import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    /*
    createMedia
    */
    createMedia ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/media`, data)
      .then((response) => {
        return response.data
      })
    },
    /*
    createMediaMultipart
    */
    createMediaMultipart ({commit, dispatch, getters, state}, formData) {
      return axios.post(`/accounts/${getters.getAccount._id}/media/multipart`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Media.js